import React from 'react';
import honey from '../photos/honey.jpg'
import queen from '../photos/queen1.jpg'
import pollen from '../photos/pollen.jpg'
import propolis from '../photos/proplis.jpg'
import '../styles/Product.css'
    function Products() {
        const products = [
            {
                name: "عسل طبيعي",
                description: "عسل المراد الطبيعي هو جوهر الطبيعة المقطوف بعناية من زهور مختارة في أفضل البيئات السورية. يتميز بخواصه المضادة للبكتيريا وفعاليته في دعم الجهاز الهضمي وتعزيز الطاقة بشكل طبيعي، ليكون خيارك المثالي للصحة والذوق الرفيع.",
                image: honey
            },
            {
                name: "غذاء الملكات",
                description: "غذاء الملكات الفاخر هو منتج طبيعي مغذٍ، غني بالفيتامينات والمعادن الأساسية. يقدم لك دفعة من الطاقة الطبيعية ويحسن من مزاجك وصحتك العامة، إلى جانب تأثيره المميز على نضارة البشرة وجمال الشعر. مثالي لتحسين جودة حياتك اليومية.",
                image: queen
            },
            {
                name: "غبار الطلع",
                description: "غبار الطلع، الكنز الطبيعي، مليء بالمغذيات التي تدعم المناعة وتقوي الجسم. يعتبر مكملًا غذائيًا مثاليًا، حيث يحتوي على البروتينات والفيتامينات ومضادات الأكسدة التي تمنحك طاقة وحيوية فريدة، مع دعم للصحة العامة.",
                image: pollen
            },
            {
                name: "عكبر النحل",
                description: "العكبر، المعروف بمضادات الأكسدة الطبيعية، هو منتج يجمعه النحل من براعم الأشجار والنباتات. يتميز بخصائصه القوية في تعزيز المناعة، محاربة البكتيريا، ودعم الصحة العامة بشكل مثالي. إضافة قيمة لمجموعة منتجاتك الصحية.",
                image: propolis
            }
        ];
        
        

    return (
        <section id="products" className="py-5 bg-light">
        <div className="container">
            <h2 className="text-center mb-4">منتجاتنا</h2>
            <div className="row">
            {products.map((product, index) => (
                <div className="col-md-4" key={index}>
                <div className="card mb-4 shadow-sm">
                    <img src={product.image} className="card-img-top imageCard" alt={product.name} />
                    <div className="card-body">
                    <h5 className="card-title txt">{product.name}</h5>
                    <br/>
                    <p className="card-text txt">{product.description}</p>
                    <br/>
                    <a href="#contact" className="btn btn-primary button">اطلب الآن</a>
                    </div>
                </div>
                </div>
            ))}
            </div>
        </div>
        </section>
    );
    }

export default Products;
